(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/radio-button.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/radio-button.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (radio_button)
  });
  ; 
  const external_React_namespaceObject = window["React"];
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }


  class RadioButton extends external_React_namespaceObject.Component {
    constructor(props) {
      super(props);
      _defineProperty(this, "handleChange", () => {
        this.props.onChange(this.props.value);
      });
      this.uniqueId = "radio-".concat(Math.round(Math.random() * 100000 + 1000));
    }
    render() {
      const {
        aria,
        branding,
        className,
        labelClass,
        inline,
        inverted,
        value,
        minWidth,
        name,
        data,
        disabled,
        checked,
        defaultChecked,
        id,
        label,
        children
      } = this.props;
      const dataAttribues = data && data.map(data => "data-".concat(data.key, "=\"").concat(data));
      const wrapperClasses = ['form-toggle'];
      const inputClasses = ['form-toggle-input', 'form-toggle-radio', 'form-toggle-button'];
      const labelClasses = ['form-label'];
      if (inline) {
        wrapperClasses.push('form-toggle-inline');
      }
      if (branding) {
        inputClasses.push("form-toggle-".concat(branding));
      } else if (inverted) {
        wrapperClasses.push('form-toggle-inverted');
        inputClasses.push('form-toggle-inverted');
      } else {
        inputClasses.push('form-toggle-default');
      }
      if (className) {
        inputClasses.push(className);
      }
      if (labelClass) {
        labelClasses.push(labelClass);
      }
      const ariaAttributes = {};
      if (aria) {
        Object.keys(aria).forEach(key => {
          if (key) {
            ariaAttributes["aria-".concat(key)] = aria[key];
          }
        });
      }
      return React.createElement("div", {
        className: wrapperClasses.join(' '),
        style: minWidth && {
          minWidth
        }
      }, React.createElement("input", _extends({}, ariaAttributes, {
        className: inputClasses.join(' '),
        id: id ? id : this.uniqueId,
        name: name ? name : 'radio[]',
        type: "radio"
      }, dataAttribues, {
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        onChange: this.handleChange,
        value: value
      })), React.createElement("label", {
        className: labelClasses.join(' '),
        htmlFor: id ? id : this.uniqueId
      }, React.createElement("div", {
        className: "form-label-text"
      }, label ? label : children)));
    }
  }
  RadioButton.propTypes = {
    aria: external_PropTypes_default().object,
    branding: external_PropTypes_default().string,
    checked: external_PropTypes_default().bool,
    children: external_PropTypes_default().node,
    className: external_PropTypes_default().string,
    data: external_PropTypes_default().array,
    defaultChecked: external_PropTypes_default().bool,
    disabled: external_PropTypes_default().bool,
    id: external_PropTypes_default().string,
    inline: external_PropTypes_default().bool,
    inverted: external_PropTypes_default().string,
    label: external_PropTypes_default().string,
    labelClass: external_PropTypes_default().string,
    minWidth: external_PropTypes_default().string,
    name: external_PropTypes_default().string,
    onChange: external_PropTypes_default().func,
    value: external_PropTypes_default().oneOfType([external_PropTypes_default().number, external_PropTypes_default().string]).isRequired
  };
  RadioButton.__docgenInfo = {
    "description": "",
    "methods": [{
      "name": "handleChange",
      "docblock": null,
      "modifiers": [],
      "params": [],
      "returns": null
    }],
    "displayName": "RadioButton",
    "props": {
      "aria": {
        "description": "",
        "type": {
          "name": "object"
        },
        "required": false
      },
      "branding": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "checked": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "className": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "data": {
        "description": "",
        "type": {
          "name": "array"
        },
        "required": false
      },
      "defaultChecked": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "disabled": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "id": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "inline": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "inverted": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "label": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "labelClass": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "minWidth": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "name": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "onChange": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "number"
          }, {
            "name": "string"
          }]
        },
        "required": true
      }
    }
  };
  const radio_button = RadioButton;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).RadioButton = __webpack_exports__["default"];
})();

 })(window);